import React from 'react'

function FBcircle() {
  return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.2166 15.5932C31.1619 7.25706 24.6406 0.418041 16.3652 0.0183404C8.08991 -0.38136 0.947566 5.7977 0.0996028 14.0902C-0.748361 22.3828 4.99389 29.8958 13.1767 31.2V19.9882H9.22111V15.5035H13.1767V12.14C13.1767 8.1822 15.5055 5.9959 19.0712 5.9959C20.24 6.01043 21.406 6.11538 22.5588 6.30983V10.1891H20.5977C20.004 10.1033 19.401 10.2619 18.925 10.629C18.449 10.9961 18.1402 11.5408 18.0683 12.14C18.0461 12.3074 18.0461 12.4771 18.0683 12.6445V15.5035H22.3916L21.7008 19.9882H18.0572V31.2C25.66 29.9598 31.2391 23.343 31.2166 15.5932Z" fill="#007BFF"/>
        </svg>
  )
}

export default FBcircle